import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { loadSection } from "../services/contentSource";
import teamFallback from "../data/home/team.json";

const SOCIAL_ICONS: Record<string, string> = {
  facebook: "fa-facebook-f",
  twitter: "fa-twitter",
  instagram: "fa-instagram",
  linkedin: "fa-linkedin",
};

const TeamDetails = () => {
  const { slug } = useParams();
  const [member, setMember] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSection("team", teamFallback as any)
      .then(({ data: main }) => {
        const members = (main as any)?.members || [];
        const found = members.find((m: any) => m.slug === slug || m.id === slug);
        setMember(found || null);
      })
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <p>Loading...</p>;
  if (!member) return <div>Team member not found.</div>;

  const bio: string[] = member.bio || [];
  const social: Record<string, string> = member.social || {};

  return (
    <>
      <link rel="stylesheet" href="/assets/css/master-team-details.css"></link>
      <main>
        {/* team details area start  */}
        <section className="team-details-area">
          <div className="container">
            <div className="team-details-area-inner section-spacing-bottom">
              <div className="section-content">
                <div className="team-thumb has_fade_anim" data-fade-from="left">
                  <div className="shape-1">
                    <img
                      className="show-light"
                      src="/assets/imgs/shape/img-s-86.webp"
                      alt="shape" loading="lazy" decoding="async" />
                    <img
                      className="show-dark"
                      src="/assets/imgs/shape/img-s-86-dark.webp"
                      alt="shape" loading="lazy" decoding="async" />
                  </div>
                  <img
                    className="main-image"
                    src={member.image}
                    alt={member.name} loading="lazy" decoding="async" />
                </div>
                <div className="content-last">
                  <div className="section-header">
                    <div className="section-title-wrapper">
                      <div className="title-wrapper">
                        <h1 className="name section-title large has_fade_anim">
                          {member.name}
                        </h1>
                      </div>
                    </div>
                    <div className="subtitle-wrapper">
                      <span className="designation section-subtitle has_fade_anim">
                        {member.role}
                      </span>
                    </div>
                    <div className="text-wrapper">
                      {bio.map((paragraph, idx) => (
                        <p className="text has_fade_anim" key={idx}>
                          {paragraph}
                        </p>
                      ))}
                    </div>
                    {member.email && (
                      <div
                        className="meta-wrapper has_fade_anim"
                        data-on-scroll={0}
                      >
                        <span className="title">Email :</span>
                        <div className="portfolio-list-wrappper">
                          <div className="portfolio-list">
                            <a href={`mailto:${member.email}`}>{member.email}</a>
                          </div>
                        </div>
                      </div>
                    )}
                    {Object.keys(social).length > 0 && (
                      <div
                        className="meta-wrapper has_fade_anim"
                        data-on-scroll={0}
                      >
                        <span className="title">Follow :</span>
                        <div className="social-links-wrappper">
                          <ul className="social-links">
                            {Object.entries(social).map(([platform, url]) => (
                              <li key={platform}>
                                <a href={url} target="_blank" rel="noopener noreferrer">
                                  <i className={`fa-brands ${SOCIAL_ICONS[platform] || "fa-link"}`} />
                                </a>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* team details area end  */}
      </main>
    </>
  );
};
export default TeamDetails;
